/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './CallToActionCard.style';

type Props = {
  children: React.Node,
};

const useStyles = createUseThemeStyles(styles);

const CallToActionCard = ({ children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <div className={classes.root}>{children}</div>;
};

export default React.memo<Props>(CallToActionCard);
